import React, { Component } from 'react'
import PhoneInput from "react-phone-input-2";
import Select from "react-select";
import * as JobOptions from '../../../../Function/defaultJobOptions'
import csc from "country-state-city";
import helperFunction from '../../../../Function/helperFunction';

class Receiverinfo extends Component {
    constructor(){
        super()
        this.state = {
            country : csc.getAllCountries() ,
            countryCode : "" ,
            cities : [] ,
            states : [] ,
        }
    }

    onCountryChange = (e,name) => {
        if (name === "country") {
            this.setState({states:csc.getStatesOfCountry(e.isoCode),countryCode:e.isoCode})
        } else if (name === "state") {
            this.setState({cities:csc.getCitiesOfState(this.state.countryCode, e.isoCode)})
        } 
        this.props.onChangeValue(e,'receiver_details',name)
      }

    
    render() {
        const {jobData, formValidator} = this.props
        if( !jobData || Object.keys(jobData).length === 0 ) return false

        return (
            <div className="card">
                <div className="card-header bg-light"><h4>Receiver Information</h4></div>
                <div className="card-body">

                    <div className="row">
                        <div className="mb-3 col-md-6 col-12">
                            <div className="mb-3">
                                <label className="form-label">Name</label>
                                <input 
                                    className="form-control form-control-sm" 
                                    name="receiver_name"
                                    value={jobData.receiver_name}
                                    onChange={(e)=>this.props.onChangeValue(e, 'receiver_details')}
                                />
                                {
                                    // formValidator.message('receiver name', jobData.receiver_name, 'required', { className: 'text-danger' })
                                }
                            </div>

                            <div className="mb-3">
                                <label className="form-label">Number</label>
                                {/* <input 
                                    className="form-control form-control-sm" 
                                    name="pickup_contact"
                                    value={jobData.pickup_contact}
                                    onChange={(e)=>this.props.onChangeValue(e, 'receiver_details')}
                                /> */}
                                <PhoneInput
                                className="telinput"
                                country={"ae"}
                                enableSearch
                                enableAreaCodes={true}
                                value={jobData.pickup_contact}
                                onChange={(phone, f, g) => this.props.onChangeValue({value: phone}, 'receiver_details', 'pickup_contact')}
                                />
                                {
                                    // formValidator.message('contact number', jobData.pickup_contact, 'phone|min:10', { className: 'text-danger' })
                                }
                            </div>

                        </div>

                        <div className="mb-3 col-md-6 col-12">
                            <div className="mb-3">
                                <label className="form-label">Email</label>
                                <input 
                                    className="form-control form-control-sm" 
                                    name="email"
                                    value={jobData.email}
                                    onChange={(e)=>this.props.onChangeValue(e, 'receiver_details')}
                                />
                                {
                                    formValidator.message('email', jobData.email, 'email', { className: 'text-danger' })
                                }
                            </div>

                            <div className="mb-3">
                                <label className="form-label">Address</label>
                                <input 
                                    className="form-control form-control-sm" 
                                    name="address"
                                    value={jobData.address}
                                    onChange={(e)=>this.props.onChangeValue(e, 'receiver_details')}
                                />
                                {
                                    // formValidator.message('email', jobData.address, 'required', { className: 'text-danger' })
                                }
                            </div>
                         </div>
                         </div>


                         <div className="row">
                        {/* <div className="mb-3 col-md-12 col-12"> */}
                        {/* country  */}
                        <div className="mb-3 col-3">
                            <label className="form-label">Country </label>
                            <Select
                                styles={{
                                valueContainer: (provided) => ({
                                    ...provided,
                                    height: "calc(2.15rem + 2px)",
                                    overflowY: "visible",
                                }),
                                control: (provider) => ({
                                    ...provider,
                                    boxShadow: "0 0 0 0px #f46a6a",
                                }),
                                placeholder: (provider) => ({
                                    ...provider,
                                    color: "#a0b0ca",
                                }),
                                }}
                                value={jobData.country ? {label:jobData.country,value:jobData.country,isoCode:this.state.countryCode} : null}
                                onChange={(e) => this.onCountryChange(e,'country')}
                                options={helperFunction.convertToSelectList(this.state.country,"name","name")}
                            />
                            </div>
                            {/* state  */}
                            <div className="mb-3 col-3">
                            <label className="form-label">State </label>
                            <Select
                                styles={{
                                valueContainer: (provided) => ({
                                    ...provided,
                                    height: "calc(2.15rem + 2px)",
                                    overflowY: "visible",
                                }),
                                control: (provider) => ({
                                    ...provider,
                                    boxShadow: "0 0 0 0px #f46a6a",
                                }),
                                placeholder: (provider) => ({
                                    ...provider,
                                    color: "#a0b0ca",
                                }),
                                }}
                                value={jobData.state ? {label:jobData.state,value:jobData.state} : null}
                                onChange={(e) => this.onCountryChange(e,'state')}
                                options={helperFunction.convertToSelectList(this.state.states,"name","name")}
                            />
                            </div>
                            {/* city  */}
                            <div className="mb-3 col-3">
                                <label className="form-label">City</label>
                                <Select
                                    styles={{
                                    valueContainer: (provided) => ({
                                        ...provided,
                                        height: "calc(2.15rem + 2px)",
                                        overflowY: "visible",
                                    }),
                                    control: (provider) => ({
                                        ...provider,
                                        boxShadow: "0 0 0 0px #f46a6a",
                                    }),
                                    placeholder: (provider) => ({
                                        ...provider,
                                        color: "#a0b0ca",
                                    }),
                                    }}
                                    value={jobData.city ? {label:jobData.city,value:jobData.city} : null}
                                    onChange={(e) => this.onCountryChange(e,'city')}
                                    options={helperFunction.convertToSelectList(this.state.cities,"name","name")}
                                />
                                </div> 
                                {/* postal_code  */}
                            <div className="mb-3 col-3">
                            <label className="form-label">Postal Code</label>
                            <input
                                type="text"
                                className={"form-control"}
                                onChange={(e) => this.onCountryChange(e,'postal_code')}
                                value={jobData.postal_code}
                                placeholder="Enter Postal Code"
                            />
                            </div>
                        {/* </div> */}
                        
                         <div className="col-3 col-md-3">
                            <div className="">
                                <label className="form-label">Area</label>
                                <Select
                                    styles={{
                                    valueContainer: (provided) => ({
                                        ...provided,
                                        height: "calc(2.15rem + 2px)",
                                        overflowY: "visible",
                                    }),
                                    control: (provider) => ({
                                        ...provider,
                                        boxShadow: "0 0 0 0px #f46a6a",
                                    }),
                                    placeholder: (provider) => ({
                                        ...provider,
                                        color: "#a0b0ca",
                                    }),
                                    }}
                                    value={jobData.area ? {label:jobData.area,value:jobData.area} : null}
                                    onChange={(e) => this.props.onChangeValue(e, 'receiver_details', "area")}
                                    options={[
                                        { label : "NORTH", value : "NORTH" },
                                        { label : "EAST", value : "EAST" },
                                        { label : "WEST", value : "WEST" },
                                        { label : "SOUTH", value : "SOUTH" },
                                    ]}
                                />
                            </div>
                        </div>
                         <div className="col-9 col-md-9">
                            <div className="">
                                <label className="form-label">Comment</label>
                                <textarea 
                                    className="form-control form-control-sm"
                                    name="comments"
                                    value={jobData.comments}
                                    onChange={(e)=>this.props.onChangeValue(e, 'receiver_details')}
                                />
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        )
    }
}

export default Receiverinfo